import asphaltImg from "../../assets/images/asphalt.png";
import metalImg from "../../assets/images/metal.png";
import tileImg from "../../assets/images/tile.png";

import flatRoofImg from "../../assets/images/flat-roof.png";
import mellowRoofImg from "../../assets/images/mellow-roof.png";
import steepRoofImg from "../../assets/images/steep-roof.png";

import yesImg from "../../assets/images/yes.png";
import noImg from "../../assets/images/no.png";
import notSureImg from "../../assets/images/not-sure.png";
import notSureAllImg from "../../assets/images/not-sure-all.png";

import YesActiveSVG from "../../assets/svgs/sunroof-active-yes.svg";
import YesSVG from "../../assets/svgs/sunroof-yes.svg";
import NoSVG from "../../assets/svgs/sunroof-no.svg";
import NoactiveSVG from "../../assets/svgs/sunroof-active-no.svg";

import YesActiveImg from "../../assets/images/owner-yes-active.png";
import YesImg from "../../assets/images/owner-yes.png";
import NoImg from "../../assets/images/owner-no.png";
import NoActiveImg from "../../assets/images/owner-no-active.png";

export const calendlyMeetingURL =
  "https://calendly.com/rrdfw/ai-roof-assessment/lp-appointment-call-back";

export const multiSteps = {
  1: "SELECT_ROOF",
  2: "SELECT_ROOF_STEEP",
  3: "SELECT_ROOF_INSURANCE",
  4: "CONTACT_INFO",
  5: "LOADING_STATE",
};

export const roofTypes = [
  {
    name: "Asphalt",
    image: asphaltImg,
  },
  {
    name: "Metal",
    image: metalImg,
  },
  {
    name: "Tile",
    image: tileImg,
  },
  // {
  //   name: "Not Sure!",
  //   image: notSureAllImg,
  // },
];

export const roofSteepness = [
  {
    name: "Flat",
    image: flatRoofImg,
  },
  {
    name: "Mellow",
    image: mellowRoofImg,
  },
  {
    name: "Steep",
    image: steepRoofImg,
  },
  // {
  //   name: "Not Sure!",
  //   image: notSureImg,
  // },
];

export const roofInsuranceOptions = [
  {
    name: "Yes",
    image: yesImg,
  },
  {
    name: "No",
    image: noImg,
  },
  {
    name: "Not Sure!",
    image: notSureImg,
  },
];

export const ownOptions = [
  {
    name: "Yes",
    image: YesImg,
    activeImage: YesActiveImg,
  },
  {
    name: "No",
    image: NoImg,
    activeImage: NoActiveImg,
  },
];
